[
  { "code": "AA", "name": { "en": "U.S. Armed Forces – Americas", "es": "Fuerzas Armadas de EE. UU. – Américas" } },
  { "code": "AE", "name": { "en": "U.S. Armed Forces – Europe", "es": "Fuerzas Armadas de EE. UU. – Europa" } },
  { "code": "AK", "name": { "en": "Alaska", "es": "Alaska" } },
  { "code": "AL", "name": { "en": "Alabama", "es": "Alabama" } },
  { "code": "AP", "name": { "en": "U.S. Armed Forces – Pacific", "es": "Fuerzas Armadas de EE. UU. – Pacífico" } },
  { "code": "AR", "name": { "en": "Arkansas", "es": "Arkansas" } },
  { "code": "AS", "name": { "en": "American Samoa", "es": "Samoa Americana" } },
  { "code": "AZ", "name": { "en": "Arizona", "es": "Arizona" } },
  { "code": "CA", "name": { "en": "California", "es": "California" } },
  { "code": "CO", "name": { "en": "Colorado", "es": "Colorado" } },
  { "code": "CT", "name": { "en": "Connecticut", "es": "Connecticut" } },
  { "code": "DC", "name": { "en": "District of Columbia", "es": "Distrito de Columbia" } },
  { "code": "DE", "name": { "en": "Delaware", "es": "Delaware" } },
  { "code": "FL", "name": { "en": "Florida", "es": "Florida" } },
  { "code": "FM", "name": { "en": "Federated States of Micronesia", "es": "Estados Federados de Micronesia" } },
  { "code": "GA", "name": { "en": "Georgia", "es": "Georgia" } },
  { "code": "GU", "name": { "en": "Guam", "es": "Guam" } },
  { "code": "HI", "name": { "en": "Hawaii", "es": "Hawái" } },
  { "code": "IA", "name": { "en": "Iowa", "es": "Iowa" } },
  { "code": "ID", "name": { "en": "Idaho", "es": "Idaho" } },
  { "code": "IL", "name": { "en": "Illinois", "es": "Illinois" } },
  { "code": "IN", "name": { "en": "Indiana", "es": "Indiana" } },
  { "code": "KS", "name": { "en": "Kansas", "es": "Kansas" } },
  { "code": "KY", "name": { "en": "Kentucky", "es": "Kentucky" } },
  { "code": "LA", "name": { "en": "Louisiana", "es": "Luisiana" } },
  { "code": "MA", "name": { "en": "Massachusetts", "es": "Massachusetts" } },
  { "code": "MD", "name": { "en": "Maryland", "es": "Maryland" } },
  { "code": "ME", "name": { "en": "Maine", "es": "Maine" } },
  { "code": "MH", "name": { "en": "Marshall Islands", "es": "Islas Marshall" } },
  { "code": "MI", "name": { "en": "Michigan", "es": "Míchigan" } },
  { "code": "MN", "name": { "en": "Minnesota", "es": "Minnesota" } },
  { "code": "MO", "name": { "en": "Missouri", "es": "Misuri" } },
  { "code": "MP", "name": { "en": "Northern Mariana Islands", "es": "Islas Marianas del Norte" } },
  { "code": "MS", "name": { "en": "Mississippi", "es": "Misisipi" } },
  { "code": "MT", "name": { "en": "Montana", "es": "Montana" } },
  { "code": "NC", "name": { "en": "North Carolina", "es": "Carolina del Norte" } },
  { "code": "ND", "name": { "en": "North Dakota", "es": "Dakota del Norte" } },
  { "code": "NE", "name": { "en": "Nebraska", "es": "Nebraska" } },
  { "code": "NH", "name": { "en": "New Hampshire", "es": "Nueva Hampshire" } },
  { "code": "NJ", "name": { "en": "New Jersey", "es": "Nueva Jersey" } },
  { "code": "NM", "name": { "en": "New Mexico", "es": "Nuevo México" } },
  { "code": "NV", "name": { "en": "Nevada", "es": "Nevada" } },
  { "code": "NY", "name": { "en": "New York", "es": "Nueva York" } },
  { "code": "OH", "name": { "en": "Ohio", "es": "Ohio" } },
  { "code": "OK", "name": { "en": "Oklahoma", "es": "Oklahoma" } },
  { "code": "OR", "name": { "en": "Oregon", "es": "Oregón" } },
  { "code": "PA", "name": { "en": "Pennsylvania", "es": "Pensilvania" } },
  { "code": "PR", "name": { "en": "Puerto Rico", "es": "Puerto Rico" } },
  { "code": "PW", "name": { "en": "Palau", "es": "Palaos" } },
  { "code": "RI", "name": { "en": "Rhode Island", "es": "Rhode Island" } },
  { "code": "SC", "name": { "en": "South Carolina", "es": "Carolina del Sur" } },
  { "code": "SD", "name": { "en": "South Dakota", "es": "Dakota del Sur" } },
  { "code": "TN", "name": { "en": "Tennessee", "es": "Tennessee" } },
  { "code": "TX", "name": { "en": "Texas", "es": "Texas" } },
  { "code": "UT", "name": { "en": "Utah", "es": "Utah" } },
  { "code": "VA", "name": { "en": "Virginia", "es": "Virginia" } },
  { "code": "VI", "name": { "en": "U.S. Virgin Islands", "es": "Islas Vírgenes de los Estados Unidos" } },
  { "code": "VT", "name": { "en": "Vermont", "es": "Vermont" } },
  { "code": "WA", "name": { "en": "Washington", "es": "Washington" } },
  { "code": "WI", "name": { "en": "Wisconsin", "es": "Wisconsin" } },
  { "code": "WV", "name": { "en": "West Virginia", "es": "Virginia Occidental" } },
  { "code": "WY", "name": { "en": "Wyoming", "es": "Wyoming" } }
]
